import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import QueryStatsRounded from '@mui/icons-material/QueryStatsRounded';
import { Stack } from '@mui/material';

import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import history from 'src/services/routing/history';
import { routePaths } from 'src/services/routing/routePaths';
import ButtonPanel from 'src/components/common/ButtonPanel';
import { useDownloadManager } from 'src/components/downloadManager/DownloadManagerContext';
import { usePlanActionContext } from 'src/components/planAction/PlanActionContext';

const PlanActionActionBanner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('planAction');
  const { selectedOrgUnit } = usePlanActionContext();
  const { poll } = useDownloadManager();

  const downloadActionPlans = useCallback(async () => {
    try {
      return await HttpService.post(
        `${apiPaths.ORG_UNIT}${selectedOrgUnit?.id}/export_action_plans/`,
        { lang: language },
      );
    } finally {
      poll();
    }
  }, [selectedOrgUnit, poll, language]);

  if (!selectedOrgUnit) return null;

  return (
    <Stack
      direction="row"
      sx={{
        height: '6rem',
      }}
    >
      <ButtonPanel
        onClick={() => history.push(routePaths.PLAN_ACTION_STATISTICS)}
      >
        <QueryStatsRounded fontSize="large" />
        <span>{t('ActionBanner.Statistics')}</span>
      </ButtonPanel>
      <ButtonPanel onClick={downloadActionPlans}>
        <DownloadRounded fontSize="large" />
        <span>{t('ActionBanner.DownloadAllActionPlans')}</span>
      </ButtonPanel>
    </Stack>
  );
};

export default PlanActionActionBanner;
